export default __webpack_public_path__ + "media/color/pot-8a95be3c.svg";